import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Gets all debit cards associated with the customer.
   * @param {String} productId - Id of the product associated with the loan.
   * @returns {Promise<{cards: [Object], validations: {canAddCard: Boolean, displayDisbursementLimitTile: Boolean, disburseLimitTileText: String, maxCardLimit: Number}}>} An array of cards and object of validation properties.
   */
  async getCards (productId) {
    Logger.info('Started get disburse card query.')
    return tmxApiCall('get', '/disburseCard', {
      params: {
        productId
      }
    })
  },

  async removeCard (cardId, productId) {
    Logger.info('Started remove disburse card query.')
    return tmxApiCall('delete', '/disburseCard', {
      data: {
        cardId,
        productId
      }
    })
  },

  /**
   * Adds a debit card to a customers list of debit cards saved with a payment processor.
   * @param {Boolean} guestCard - Flag if the card to add is a guest card.
   * @param {String} tokenPayTempToken - The BridgePay tokenized card.
   * @param {Number|String} productId - The productId of the loan.
   * @returns {Promise<{card: {cardIds: String, cardNumber: String, name: String, customerId: String, customerIds: [], guestCard: Boolean}}>} A debit card object.
   */
  async addDisburseCard (guestCard, tokenPayTempToken, productId) {
    Logger.info('Started Add Card query.')
    return tmxApiCall('post', '/disburseCard', {
      guestCard,
      tokenPayTempToken,
      productId
    })
  },

  /**
   * Gets their current status of the secure acceptance session. Once customer submits card info, postback to API generates a status.
   * @param {String} transactionUuid - The UUID for the card transaction to check.
   * @returns {Promise<Object>} The secure acceptance card transaction status.
   */
  async getSecureAcceptStatus (transactionUuid) {
    Logger.info('Getting secure accept card transaction status')
    return tmxApiCall('get', '/cardSecureAcceptance', {
      params: {
        transactionUuid
      }
    })
  }
}
